__turbopack_context__.v({
  "browserBar": "ScreenshotCarousel-module-scss-module__chDA5G__browserBar",
  "carousel": "ScreenshotCarousel-module-scss-module__chDA5G__carousel",
  "dot": "ScreenshotCarousel-module-scss-module__chDA5G__dot",
  "dotActive": "ScreenshotCarousel-module-scss-module__chDA5G__dotActive",
  "dotBtn": "ScreenshotCarousel-module-scss-module__chDA5G__dotBtn",
  "dotRow": "ScreenshotCarousel-module-scss-module__chDA5G__dotRow",
  "dots": "ScreenshotCarousel-module-scss-module__chDA5G__dots",
  "frame": "ScreenshotCarousel-module-scss-module__chDA5G__frame",
  "green": "ScreenshotCarousel-module-scss-module__chDA5G__green",
  "lightbox": "ScreenshotCarousel-module-scss-module__chDA5G__lightbox",
  "lightboxBackdrop": "ScreenshotCarousel-module-scss-module__chDA5G__lightboxBackdrop",
  "lightboxClose": "ScreenshotCarousel-module-scss-module__chDA5G__lightboxClose",
  "lightboxImage": "ScreenshotCarousel-module-scss-module__chDA5G__lightboxImage",
  "lightboxImageWrap": "ScreenshotCarousel-module-scss-module__chDA5G__lightboxImageWrap",
  "lightboxInner": "ScreenshotCarousel-module-scss-module__chDA5G__lightboxInner",
  "lightboxNav": "ScreenshotCarousel-module-scss-module__chDA5G__lightboxNav",
  "lightboxNext": "ScreenshotCarousel-module-scss-module__chDA5G__lightboxNext",
  "lightboxPrev": "ScreenshotCarousel-module-scss-module__chDA5G__lightboxPrev",
  "lightboxStage": "ScreenshotCarousel-module-scss-module__chDA5G__lightboxStage",
  "overlayCaptionSubtitle": "ScreenshotCarousel-module-scss-module__chDA5G__overlayCaptionSubtitle",
  "overlayCaptionTitle": "ScreenshotCarousel-module-scss-module__chDA5G__overlayCaptionTitle",
  "progressBar": "ScreenshotCarousel-module-scss-module__chDA5G__progressBar",
  "progressFill": "ScreenshotCarousel-module-scss-module__chDA5G__progressFill",
  "red": "ScreenshotCarousel-module-scss-module__chDA5G__red",
  "screenshotWrapper": "ScreenshotCarousel-module-scss-module__chDA5G__screenshotWrapper",
  "slide": "ScreenshotCarousel-module-scss-module__chDA5G__slide",
  "slideOverlay": "ScreenshotCarousel-module-scss-module__chDA5G__slideOverlay",
  "thumb": "ScreenshotCarousel-module-scss-module__chDA5G__thumb",
  "thumbActive": "ScreenshotCarousel-module-scss-module__chDA5G__thumbActive",
  "thumbStrip": "ScreenshotCarousel-module-scss-module__chDA5G__thumbStrip",
  "track": "ScreenshotCarousel-module-scss-module__chDA5G__track",
  "urlBar": "ScreenshotCarousel-module-scss-module__chDA5G__urlBar",
  "urlText": "ScreenshotCarousel-module-scss-module__chDA5G__urlText",
  "viewport": "ScreenshotCarousel-module-scss-module__chDA5G__viewport",
  "yellow": "ScreenshotCarousel-module-scss-module__chDA5G__yellow",
});
